import React, { useCallback, useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import './LandingPage.css';
import './KojiSiTipIgraca.css';
import { useSeo } from '../hooks/useSeo';
import { useJsonLd } from '../hooks/useJsonLd';
import FaqItem from './FaqItem';
import PublicPageNav from './PublicPageNav';


/**
 * Atribut vektor (8 dimenzija):
 *  ATT, MID, DEF, GK   - pozicijske preferencije (0-10)
 *  SPEED, POWER        - fizički profil (0-10)
 *  TECH, VISION        - kreativni profil (0-10)
 *  FINISH, DEFEND      - finalni potez / obrambeni instinkt (0-10)
 *  LEAD                - mentalitet (0-10)
 */
const PLAYERS = [
  {
    id: 'ronaldo',
    name: 'Cristiano Ronaldo',
    nickname: 'CR7 — stroj za golove',
    emoji: '🐐',
    color: '#dc2626',
    accent: '#0f172a',
    vector: { ATT: 10, MID: 0, DEF: 0, GK: 0, SPEED: 7, POWER: 9, TECH: 8, VISION: 5, FINISH: 10, DEFEND: 1, LEAD: 10 },
    tagline: 'Gol je tvoj kisik. Skoči više od svih, šutiraj od 30 metara, ne odustaješ nikad.',
    strengths: ['Zabijaš sve što leti', 'Ego veličine stadiona — i to ti pomaže', 'Glavom > svi'],
    weaknesses: ['Pas? Ne, hvala', 'Sve mora biti preko tebe'],
    advice: 'Ne sumnjaj u sebe — već si sve odlučio prije nego što je suigrač podigao pogled.',
  },
  {
    id: 'messi',
    name: 'Lionel Messi',
    nickname: 'La Pulga — magija u nogama',
    emoji: '🪄',
    color: '#0ea5e9',
    accent: '#1e3a8a',
    vector: { ATT: 9, MID: 6, DEF: 0, GK: 0, SPEED: 7, POWER: 3, TECH: 10, VISION: 10, FINISH: 9, DEFEND: 1, LEAD: 8 },
    tagline: 'Smiren si, sitan i tehnički neuhvatljiv. Driblaš pet protivnika i daješ pas iz neviđenog kuta.',
    strengths: ['Lijeva noga = umjetnost', 'Vidiš pas tri sekunde prije svih', 'Šut iz škara — nepogrešiv'],
    weaknesses: ['Pretvrd start te zaustavi', 'Defenziva nije tvoja stranica'],
    advice: 'Ne moraš trčati 90 minuta — dovoljno je 5 ključnih dodira po utakmici.',
  },
  {
    id: 'mbappe',
    name: 'Kylian Mbappé',
    nickname: 'Brzina svjetlosti',
    emoji: '🚀',
    color: '#1d4ed8',
    accent: '#fbbf24',
    vector: { ATT: 10, MID: 0, DEF: 0, GK: 0, SPEED: 10, POWER: 6, TECH: 8, VISION: 6, FINISH: 9, DEFEND: 1, LEAD: 6 },
    tagline: 'Daj ti loptu u prazno — nestao si. Eksplozivan si, samouvjeren, i kad uđeš u brzinu, gotovo je.',
    strengths: ['Brzina koja lomi obrane', 'Hladna glava 1-na-1 s vratarom', 'Igra u prostor — savršeno tempiranje'],
    weaknesses: ['Igra leđima okrenutim golu nije tvoja', 'Defenzivni rad — povremeno'],
    advice: 'Tvoja najveća snaga je prvih 10 metara. Iskoristi ih, ne čekaj loptu, traži je u trku.',
  },
  {
    id: 'haaland',
    name: 'Erling Haaland',
    nickname: 'Tank u kaznenom prostoru',
    emoji: '🦾',
    color: '#0ea5e9',
    accent: '#facc15',
    vector: { ATT: 10, MID: 0, DEF: 0, GK: 0, SPEED: 8, POWER: 10, TECH: 6, VISION: 3, FINISH: 10, DEFEND: 1, LEAD: 6 },
    tagline: 'Visok, jak, brz — i bezosjećajan ispred gola. Tvoja jedina misija: pretvoriti dodir u gol.',
    strengths: ['Fizički nadmoćan u "šesnaestercu"', 'Lijeva, desna, glava — sve ulazi', 'Mirisi gol s pola terena'],
    weaknesses: ['Ne sudjeluješ puno u izgradnji', 'Ne tražiš loptu izvan zone'],
    advice: 'Stoj u "šesnaestercu". Tu si najopasniji. Jedan dodir, jedan šut, jedan gol.',
  },
  {
    id: 'vinicius',
    name: 'Vinícius Júnior',
    nickname: 'Krilo iz pakla za branitelje',
    emoji: '⚡',
    color: '#fbbf24',
    accent: '#1e3a8a',
    vector: { ATT: 9, MID: 0, DEF: 0, GK: 0, SPEED: 10, POWER: 5, TECH: 9, VISION: 7, FINISH: 7, DEFEND: 1, LEAD: 5 },
    tagline: 'Dribling, finta, brzina, ponovno dribling. Nema branitelja koji bi te držao 90 minuta.',
    strengths: ['1-na-1 si kraljica i kralj', 'Promjena ritma vara sve', 'Centrašuti i probojni driblinzi'],
    weaknesses: ['Ponekad jedan dribling previše', 'Glava nije ti glavno oružje'],
    advice: 'Idi u 1-na-1 kad god možeš. Tvoj mozak je sporiji od tvojih nogu — pusti ih da rade.',
  },
  {
    id: 'salah',
    name: 'Mohamed Salah',
    nickname: 'Egipatski faraon',
    emoji: '👑',
    color: '#dc2626',
    accent: '#0f172a',
    vector: { ATT: 9, MID: 5, DEF: 0, GK: 0, SPEED: 9, POWER: 6, TECH: 8, VISION: 7, FINISH: 9, DEFEND: 2, LEAD: 7 },
    tagline: 'Krilo koje misli kao napadač. Ulaziš s desne strane, presijecaš lijevom — i lopta je u mreži.',
    strengths: ['Ulaz s krila u zonu — smrtonosno', 'Šut izvan šesnaesterca', 'Konstantnost cijelu sezonu'],
    weaknesses: ['Glavom — slabije', 'Suočavanje s leđima — ne tvoja igra'],
    advice: 'Tvoja "cut-inside" je tvoj potpis. Trener ti zna što radiš, ali svejedno ne može stati.',
  },
  {
    id: 'kdb',
    name: 'Kevin De Bruyne',
    nickname: 'Crveni dirigent',
    emoji: '🎯',
    color: '#0ea5e9',
    accent: '#0f172a',
    vector: { ATT: 0, MID: 10, DEF: 0, GK: 0, SPEED: 6, POWER: 7, TECH: 9, VISION: 10, FINISH: 7, DEFEND: 3, LEAD: 8 },
    tagline: 'Vidiš teren kao šahovsku tablu. Pas iza obrane, centaršut iz prve, šut iz daljine — sve je oružje.',
    strengths: ['Pas iz neviđenog kuta', 'Centaršut iz trke', 'Šut iz daljine'],
    weaknesses: ['Brzina nije tvoj jaki adut', 'Povremeno previše rizika u pasu'],
    advice: 'Ne moraš nositi loptu — neka ona radi za tebe. Jedan tvoj pas vrijedi 50 driblinga.',
  },
  {
    id: 'modric',
    name: 'Luka Modrić',
    nickname: 'Mali genij',
    emoji: '🧠',
    color: '#dc2626',
    accent: '#1e293b',
    vector: { ATT: 0, MID: 10, DEF: 0, GK: 0, SPEED: 5, POWER: 4, TECH: 10, VISION: 10, FINISH: 6, DEFEND: 4, LEAD: 10 },
    tagline: 'Sitan si, ali igra ide kroz tebe. Okrećeš se na 360 stupnjeva i otvaraš teren jednim dodirom.',
    strengths: ['Tehnika prve klase', 'Vodstvo bez vikanja', 'Mirno čuvanje lopte pod pritiskom'],
    weaknesses: ['Tjelesna nadmoć — ne tvoj fokus', 'Brzina kratke distance — solidna, ne eksplozivna'],
    advice: 'Igra ti je ples. Strpljen si — kad ostali jure, ti čekaš pravi trenutak.',
  },
  {
    id: 'kroos',
    name: 'Toni Kroos',
    nickname: 'Metronom',
    emoji: '📐',
    color: '#0f172a',
    accent: '#dc2626',
    vector: { ATT: 0, MID: 10, DEF: 0, GK: 0, SPEED: 4, POWER: 4, TECH: 10, VISION: 9, FINISH: 5, DEFEND: 4, LEAD: 8 },
    tagline: 'Lopta ne ulazi u tvoju nogu i ne izlazi krivo. Lažeš tempo igre kao malo tko.',
    strengths: ['Neprecizan pas? Ne postoji', 'Stojiš na mjestu — i vladaš utakmicom', 'Slobodni udarci i centaršuti'],
    weaknesses: ['Trči kao da plaća benzin', 'Driblinzi 1-na-1 — ne baš'],
    advice: 'Tvoj mozak je tvoj sprint. Ne moraš juriti — pravi pas radi za tebe.',
  },
  {
    id: 'bellingham',
    name: 'Jude Bellingham',
    nickname: 'Box-to-box stroj',
    emoji: '🔥',
    color: '#facc15',
    accent: '#1e3a8a',
    vector: { ATT: 6, MID: 9, DEF: 0, GK: 0, SPEED: 7, POWER: 8, TECH: 8, VISION: 8, FINISH: 8, DEFEND: 5, LEAD: 9 },
    tagline: 'Trčiš svuda, daješ asistencije, zabijaš golove i još imaš snage za presing. Box-to-box dream.',
    strengths: ['Energija za dva igrača', 'Ulazak u "šesnaestercu" iz drugog plana', 'Liderstvo s 21 godinom'],
    weaknesses: ['Ponekad se previše isforsiraš', 'Početak karijere — još raste'],
    advice: 'Tvoja energija je oružje. Svaka utakmica je 90 minuta — i zadnjih 10 si ti najbolji.',
  },
  {
    id: 'kante',
    name: "N'Golo Kanté",
    nickname: 'Lopta-magnet',
    emoji: '🦾',
    color: '#0ea5e9',
    accent: '#fbbf24',
    vector: { ATT: 0, MID: 10, DEF: 0, GK: 0, SPEED: 8, POWER: 7, TECH: 7, VISION: 5, FINISH: 4, DEFEND: 10, LEAD: 7 },
    tagline: 'Sitan si, brz, izdržljiv — i loptu uvijek ukradeš prije nego što suigrač pomisli na pas.',
    strengths: ['Defenzivni rad bez kraja', 'Pluća za tri', 'Skroman, ekipni igrač'],
    weaknesses: ['Ne tražiš pažnju — i ne dobivaš je', 'Šut s daljine — minimum'],
    advice: 'Tvoja vrijednost se vidi tek kad te nema. Nastavi raditi tiho — statistika dribling-pokrivanja te voli.',
  },
  {
    id: 'pedri',
    name: 'Pedri',
    nickname: 'Iberijski talent',
    emoji: '🎼',
    color: '#dc2626',
    accent: '#facc15',
    vector: { ATT: 0, MID: 10, DEF: 0, GK: 0, SPEED: 6, POWER: 3, TECH: 10, VISION: 9, FINISH: 5, DEFEND: 3, LEAD: 5 },
    tagline: 'Tehničar s receptom za lopту pod pritiskom. Mlad, smiren, igra koja izgleda lako.',
    strengths: ['Prvi dodir — savršen', 'Igra u uskim prostorima', 'Tihi vođa kreativne igre'],
    weaknesses: ['Fizika je još u izgradnji', 'Ranjiv na čvrste startove'],
    advice: 'Tvoja tehnika nadoknađuje fiziku. Ne pokušavaj biti netko drugi — igraj svoj pas, svoj tempo.',
  },
  {
    id: 'vvd',
    name: 'Virgil van Dijk',
    nickname: 'Veliki Holanđanin',
    emoji: '🛡️',
    color: '#dc2626',
    accent: '#0f172a',
    vector: { ATT: 0, MID: 0, DEF: 10, GK: 0, SPEED: 7, POWER: 10, TECH: 7, VISION: 6, FINISH: 3, DEFEND: 10, LEAD: 10 },
    tagline: 'Visok, jak, smiren. Voliš igrati visoku liniju, "čitaš" napadače i nikad nisi pod pritiskom.',
    strengths: ['Glavom dominiraš', 'Smirenost čak i u 90. minuti', 'Vođa zadnje linije'],
    weaknesses: ['Tehnika 1-na-1 protiv brzog krila', 'Ne voliš ulaziti u rizične startove'],
    advice: 'Pozicija prije sprinta. Ti si shvatljiv — i to je tvoja super-moć.',
  },
  {
    id: 'taa',
    name: 'Trent Alexander-Arnold',
    nickname: 'Bočni s mozgom veznog',
    emoji: '🎯',
    color: '#dc2626',
    accent: '#0ea5e9',
    vector: { ATT: 0, MID: 0, DEF: 9, GK: 0, SPEED: 7, POWER: 5, TECH: 9, VISION: 9, FINISH: 5, DEFEND: 6, LEAD: 6 },
    tagline: 'Bočni branič koji zapravo igra kao playmaker. Centaršut, dijagonala, slobodni udarac — sve.',
    strengths: ['Centaršut iz trke', 'Slobodni udarci', 'Pas kroz teren'],
    weaknesses: ['Defenzivno 1-na-1 ti je slabija strana', 'Klizeći startovi — ne tvoj alat'],
    advice: 'Tvoja noga je oružje, ne tvoja klizeća. Igraj visoko, ostavi 1-na-1 stoperu.',
  },
  {
    id: 'hakimi',
    name: 'Achraf Hakimi',
    nickname: 'Sprintaš s desne strane',
    emoji: '🔥',
    color: '#dc2626',
    accent: '#16a34a',
    vector: { ATT: 6, MID: 0, DEF: 8, GK: 0, SPEED: 10, POWER: 6, TECH: 8, VISION: 6, FINISH: 5, DEFEND: 7, LEAD: 7 },
    tagline: 'Bočni branič s motorom Formule 1. Trčiš gore-dolje 90 minuta, asistiraš, zabijaš.',
    strengths: ['Brzina kroz cijeli teren', 'Pretrčavanje bočnog krila', 'Centaršut iz trke'],
    weaknesses: ['Ponekad ostavljen u defenzivnoj poziciji', 'Igra glavom — solidna, ne nadmoćna'],
    advice: 'Tvoji sprintovi su tvoja vizit-karta. Trči, kreni, vrati se — i opet.',
  },
  {
    id: 'neuer',
    name: 'Manuel Neuer',
    nickname: 'Sweeper-keeper',
    emoji: '🧤',
    color: '#16a34a',
    accent: '#0f172a',
    vector: { ATT: 0, MID: 0, DEF: 0, GK: 10, SPEED: 5, POWER: 8, TECH: 8, VISION: 7, FINISH: 1, DEFEND: 10, LEAD: 10 },
    tagline: 'Više od vratara — drugi stoper. Igraš nogom kao vezni, izlaziš pred šesnaesterac, dirigiraš obranom.',
    strengths: ['Refleksi prve klase', 'Igra nogom — kao igrač', 'Hladna glava'],
    weaknesses: ['Visoka linija — povremeno te kažnjava', 'Šut izdaleka — ne tvoja briga'],
    advice: 'Vrata su tvoj posao, ali teren je tvoj. Drži obranu, prodriži loptu, i ne boj se izaći.',
  },
];

const QUESTIONS = [
  {
    id: 'q1',
    label: 'Koja je tvoja prirodna pozicija na terenu?',
    options: [
      { label: 'Napadač / "deveti"', delta: { ATT: 8, FINISH: 2 } },
      { label: 'Krilo (lijevo / desno)', delta: { ATT: 6, SPEED: 3 } },
      { label: 'Vezni — kreativac', delta: { MID: 8, VISION: 2 } },
      { label: 'Defenzivni vezni', delta: { MID: 6, DEFEND: 4 } },
      { label: 'Bočni branič', delta: { DEF: 6, SPEED: 3 } },
      { label: 'Stoper', delta: { DEF: 8, POWER: 3 } },
      { label: 'Vratar', delta: { GK: 10, DEFEND: 3 } },
    ],
  },
  {
    id: 'q2',
    label: 'Što ti je najveći užitak na terenu?',
    options: [
      { label: 'Zabiti gol', delta: { FINISH: 5, ATT: 2 } },
      { label: 'Dati ključnu asistenciju', delta: { VISION: 5, MID: 2 } },
      { label: 'Driblati i provući protivnika', delta: { TECH: 5, ATT: 1 } },
      { label: 'Spektakularna obrana ili presretanje', delta: { DEFEND: 5, DEF: 2 } },
    ],
  },
  {
    id: 'q3',
    label: 'Tvoj fizički profil najbolje opisuje:',
    options: [
      { label: 'Visok i jak — dominiram fizički', delta: { POWER: 5, DEF: 1 } },
      { label: 'Brz kao munja', delta: { SPEED: 5, ATT: 1 } },
      { label: 'Sitan, tehničan, brz na nogama', delta: { TECH: 4, SPEED: 2 } },
      { label: 'Izdržljiv — trčim 90 minuta bez problema', delta: { DEFEND: 3, MID: 3 } },
    ],
  },
  {
    id: 'q4',
    label: 'Kako rješavaš pritisak protivnika?',
    options: [
      { label: 'Iskoristim brzinu da pobjegnem', delta: { SPEED: 5 } },
      { label: 'Odigram jednostavno, jedan-dva s suigračem', delta: { VISION: 4, TECH: 2 } },
      { label: 'Dribling, finta, izlazak', delta: { TECH: 5 } },
      { label: 'Šut iz prve, ne dam loptu', delta: { FINISH: 4, ATT: 1 } },
    ],
  },
  {
    id: 'q5',
    label: 'Tvoj omiljeni potez:',
    options: [
      { label: 'Bicikl ili volej', delta: { FINISH: 4, ATT: 2 } },
      { label: 'Maradona finta / panna', delta: { TECH: 5 } },
      { label: 'Pas iza obrane "u prazno"', delta: { VISION: 5, MID: 1 } },
      { label: 'Klizeći start ili presretanje', delta: { DEFEND: 5, POWER: 1 } },
    ],
  },
  {
    id: 'q6',
    label: 'Tvoja uloga u svlačionici je:',
    options: [
      { label: 'Vođa — motiviram ekipu', delta: { LEAD: 5 } },
      { label: 'Tihi profesionalac', delta: { TECH: 2, DEFEND: 2 } },
      { label: 'Šaljivac — razbijam tenziju', delta: { ATT: 2, MID: 1 } },
      { label: 'Slušam i učim', delta: { VISION: 2, MID: 1 } },
    ],
  },
  {
    id: 'q7',
    label: 'Tvoj stil igre je više:',
    options: [
      { label: 'Eksplozivan i impulzivan', delta: { SPEED: 3, FINISH: 2 } },
      { label: 'Smiren i hladnokrvan', delta: { TECH: 3, VISION: 2 } },
      { label: 'Tvrd i borben', delta: { POWER: 3, DEFEND: 2 } },
      { label: 'Karizmatičan — nosim ekipu', delta: { LEAD: 5 } },
    ],
  },
  {
    id: 'q8',
    label: 'Ekipa gubi 0:1, 10 minuta do kraja. Što radiš?',
    options: [
      { label: 'Sam idem riješiti — driblam i šutiram', delta: { FINISH: 3, TECH: 2, ATT: 2 } },
      { label: 'Smirim igru, organiziram napad', delta: { VISION: 4, MID: 2 } },
      { label: 'Trčim svuda, presing po lopti', delta: { DEFEND: 3, MID: 2 } },
      { label: 'Idem prema gore i tražim pas iza obrane', delta: { SPEED: 3, ATT: 2 } },
    ],
  },
  {
    id: 'q9',
    label: 'Tvoj idol — koji tip igrača?',
    options: [
      { label: 'Klasični napadač "9-ka"', delta: { FINISH: 4, POWER: 2, ATT: 2 } },
      { label: 'Kreativni "10-ka"', delta: { VISION: 5, TECH: 3, MID: 1 } },
      { label: 'Box-to-box vezni', delta: { DEFEND: 2, MID: 3, POWER: 2 } },
      { label: 'Stoper-vođa', delta: { DEF: 5, LEAD: 3 } },
    ],
  },
  {
    id: 'q10',
    label: 'Tvoja mentalna jakost najbolje opisuje:',
    options: [
      { label: 'Stalno tražim loptu — želim biti u centru igre', delta: { LEAD: 3, ATT: 2, FINISH: 1 } },
      { label: 'Strpljiv — čekam svoj trenutak', delta: { TECH: 3, MID: 1, VISION: 1 } },
      { label: 'Borac do kraja — nikad ne odustajem', delta: { LEAD: 4, DEFEND: 2, POWER: 1 } },
      { label: 'Hladna glava u najtežim trenucima', delta: { LEAD: 3, GK: 2, DEFEND: 1 } },
    ],
  },
];

const VECTOR_KEYS = ['ATT', 'MID', 'DEF', 'GK', 'SPEED', 'POWER', 'TECH', 'VISION', 'FINISH', 'DEFEND', 'LEAD'];
const POSITION_KEYS = ['ATT', 'MID', 'DEF', 'GK'];

const cosineSim = (a, b) => {
  let dot = 0;
  let aMag = 0;
  let bMag = 0;
  for (const k of VECTOR_KEYS) {
    // pojačavamo poziciju da rezultat bude pozicijski koherentan
    const w = POSITION_KEYS.includes(k) ? 1.8 : 1.0;
    const av = (a[k] || 0) * w;
    const bv = (b[k] || 0) * w;
    dot += av * bv;
    aMag += av * av;
    bMag += bv * bv;
  }
  if (aMag === 0 || bMag === 0) return 0;
  return dot / (Math.sqrt(aMag) * Math.sqrt(bMag));
};

const computeResult = (answers) => {
  const user = {};
  for (const k of VECTOR_KEYS) user[k] = 0;

  for (const a of answers) {
    if (!a) continue;
    for (const [k, v] of Object.entries(a)) {
      user[k] = (user[k] || 0) + v;
    }
  }

  let best = PLAYERS[0];
  let bestScore = -Infinity;
  const ranked = PLAYERS.map((p) => {
    const s = cosineSim(user, p.vector);
    if (s > bestScore) {
      bestScore = s;
      best = p;
    }
    return { player: p, score: s };
  }).sort((a, b) => b.score - a.score);

  return { user, best, ranked };
};

const FAQ_ITEMS = [
  {
    question: 'Kako quiz odlučuje koji sam tip igrača?',
    answer:
      'Svaki tvoj odgovor dodaje "bodove" u 11 atributa (pozicija, brzina, tehnika, vizija, fizika, mentalitet itd.). Na kraju se tvoj profil uspoređuje sa svakim od 16 igrača i pronalazimo onog s najsličnijim profilom. Algoritam koristi tzv. cosine similarity — standardnu mjeru sličnosti vektora.',
  },
  {
    question: 'Mogu li ponoviti quiz?',
    answer:
      'Naravno — ponovi koliko god puta želiš. Klikni "Pokreni ponovo" ili promijeni odgovore na odlučujućim pitanjima. Nema registracije, ne pamtimo odgovore.',
  },
  {
    question: 'Mogu li podijeliti rezultat na društvenim mrežama?',
    answer:
      'Da. Svaki rezultat ima gumb "Preuzmi sliku" koji generira PNG u formatu 1080×1920 (savršen za Instagram story i TikTok). Sliku možeš odmah objaviti.',
  },
  {
    question: 'Tko su igrači u rezultatima?',
    answer:
      'Šesnaest globalnih nogometaša s različitim profilima — od klasičnih napadača (Ronaldo, Haaland) preko kreativnih veznih (Modrić, KDB, Kroos) do branitelja (Van Dijk, Hakimi) i vratara (Neuer). Cilj je pokriti široki spektar stilova.',
  },
  {
    question: 'Je li quiz besplatan?',
    answer:
      'Da. Sve StatArena alati su besplatni i rade direktno u pregledniku — bez registracije, bez instalacije, bez plaćanja.',
  },
];

const FAQ_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQ_ITEMS.map((item) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

const SOFTWARE_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'WebApplication',
  name: 'Koji si tip igrača? - Nogometni quiz | StatArena',
  url: 'https://statarena.app/koji-si-igrac',
  description:
    'Besplatan online quiz koji ti otkriva kojeg poznatog nogometaša najviše podsjećaš — Modrić, Ronaldo, Mbappé, Haaland, Messi i drugi. 10 pitanja, rezultat za 60 sekundi, slika spremna za dijeljenje.',
  applicationCategory: 'GameApplication',
  operatingSystem: 'Web',
  browserRequirements: 'Requires JavaScript. Requires HTML5.',
  inLanguage: 'hr',
  isAccessibleForFree: true,
  offers: {
    '@type': 'Offer',
    price: '0',
    priceCurrency: 'EUR',
  },
  genre: 'Sports',
  publisher: {
    '@type': 'Organization',
    name: 'StatArena',
    url: 'https://statarena.app',
    logo: 'https://statarena.app/icon-512.png',
  },
};

const BREADCRUMB_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Početna',
      item: 'https://statarena.app/',
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Koji si tip igrača?',
      item: 'https://statarena.app/koji-si-igrac',
    },
  ],
};

// Canvas — generira PNG za dijeljenje (Instagram story / TikTok format)
const generateShareImage = async (player) => {
  const W = 1080;
  const H = 1920;
  const canvas = document.createElement('canvas');
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext('2d');

  // pozadina — gradient
  const grad = ctx.createLinearGradient(0, 0, 0, H);
  grad.addColorStop(0, player.color || '#0ea5e9');
  grad.addColorStop(1, player.accent || '#0f172a');
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, W, H);

  // suptilni "noise" / dijagonalne linije
  ctx.save();
  ctx.globalAlpha = 0.06;
  ctx.strokeStyle = '#ffffff';
  ctx.lineWidth = 2;
  for (let x = -H; x < W + H; x += 28) {
    ctx.beginPath();
    ctx.moveTo(x, 0);
    ctx.lineTo(x + H, H);
    ctx.stroke();
  }
  ctx.restore();

  // header — branding
  ctx.fillStyle = 'rgba(255,255,255,0.85)';
  ctx.font = 'bold 38px system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';
  ctx.textAlign = 'center';
  ctx.fillText('⚽ STATARENA · Koji si tip igrača?', W / 2, 110);

  // emoji veliki
  ctx.font = '300px serif';
  ctx.textAlign = 'center';
  ctx.fillText(player.emoji || '⚽', W / 2, 540);

  // "Ti si"
  ctx.fillStyle = 'rgba(255,255,255,0.75)';
  ctx.font = 'bold 56px system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';
  ctx.fillText('TI SI', W / 2, 700);

  // ime igrača (može biti dugačko)
  ctx.fillStyle = '#ffffff';
  ctx.font = 'bold 110px system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';
  // wrap ako treba
  const fitName = (name, maxWidth) => {
    ctx.font = 'bold 110px system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';
    let size = 110;
    while (ctx.measureText(name).width > maxWidth && size > 60) {
      size -= 6;
      ctx.font = `bold ${size}px system-ui, -apple-system, "Segoe UI", Roboto, sans-serif`;
    }
    return size;
  };
  fitName(player.name, W - 120);
  ctx.fillText(player.name, W / 2, 830);

  // nadimak
  ctx.fillStyle = 'rgba(255,255,255,0.85)';
  ctx.font = 'italic 44px system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';
  ctx.fillText(player.nickname, W / 2, 910);

  // tagline (wrap u više linija)
  const wrapText = (text, maxWidth, fontSize) => {
    ctx.font = `500 ${fontSize}px system-ui, -apple-system, "Segoe UI", Roboto, sans-serif`;
    const words = text.split(' ');
    const lines = [];
    let current = '';
    for (const w of words) {
      const test = current ? `${current} ${w}` : w;
      if (ctx.measureText(test).width <= maxWidth) {
        current = test;
      } else {
        if (current) lines.push(current);
        current = w;
      }
    }
    if (current) lines.push(current);
    return lines;
  };

  const taglineLines = wrapText(player.tagline, W - 160, 44);
  ctx.fillStyle = 'rgba(255,255,255,0.92)';
  ctx.font = '500 44px system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';
  let y = 1080;
  for (const line of taglineLines.slice(0, 5)) {
    ctx.fillText(line, W / 2, y);
    y += 60;
  }

  // "tvoje jake strane"
  y = Math.max(y + 60, 1380);
  ctx.fillStyle = 'rgba(255,255,255,0.7)';
  ctx.font = 'bold 36px system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';
  ctx.fillText('TVOJE JAKE STRANE', W / 2, y);
  y += 60;

  ctx.fillStyle = '#ffffff';
  ctx.font = '500 38px system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';
  for (const s of (player.strengths || []).slice(0, 3)) {
    ctx.fillText(`✓ ${s}`, W / 2, y);
    y += 56;
  }

  // CTA
  ctx.fillStyle = 'rgba(0,0,0,0.35)';
  ctx.fillRect(0, H - 200, W, 200);

  ctx.fillStyle = '#ffffff';
  ctx.font = 'bold 56px system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';
  ctx.textAlign = 'center';
  ctx.fillText('Otkrij svoj tip:', W / 2, H - 130);

  ctx.fillStyle = '#facc15';
  ctx.font = 'bold 64px system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';
  ctx.fillText('statarena.app/koji-si-igrac', W / 2, H - 50);

  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), 'image/png', 0.95);
  });
};

const KojiSiTipIgraca = () => {
  useSeo({
    title: 'Koji si tip igrača? - Nogometni quiz | StatArena',
    description:
      'Quiz u 10 pitanja koji ti otkriva kojeg poznatog nogometaša najviše podsjećaš. Modrić, Ronaldo, Mbappé, Haaland... Rezultat za 60 sekundi, slika spremna za Instagram story i TikTok.',
    canonical: 'https://statarena.app/koji-si-igrac',
    robots: 'index, follow, max-image-preview:large',
    ogUrl: 'https://statarena.app/koji-si-igrac',
    ogTitle: 'Koji si tip igrača? - Nogometni quiz',
    ogDescription:
      '10 pitanja, jedan rezultat. Koji od 16 svjetskih zvijezda si ti? Sliku za Instagram i TikTok dobiješ odmah.',
  });

  useJsonLd('koji-si-igrac-software', SOFTWARE_JSONLD);
  useJsonLd('koji-si-igrac-faq', FAQ_JSONLD);
  useJsonLd('koji-si-igrac-breadcrumb', BREADCRUMB_JSONLD);

  // 'intro' | 'quiz' | 'result'
  const [phase, setPhase] = useState('intro');
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState(Array(QUESTIONS.length).fill(null));
  const [downloading, setDownloading] = useState(false);
  const [shareCopied, setShareCopied] = useState(false);
  const resultRef = useRef(null);

  const result = useMemo(() => {
    if (phase !== 'result') return null;
    return computeResult(answers);
  }, [phase, answers]);

  const start = useCallback(() => {
    setAnswers(Array(QUESTIONS.length).fill(null));
    setStep(0);
    setPhase('quiz');
    setShareCopied(false);
  }, []);

  const selectOption = useCallback(
    (questionIndex, option) => {
      const next = [...answers];
      next[questionIndex] = option.delta;
      setAnswers(next);

      if (questionIndex + 1 < QUESTIONS.length) {
        setStep(questionIndex + 1);
      } else {
        setPhase('result');
        setTimeout(() => {
          if (resultRef.current) {
            resultRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 80);
      }
    },
    [answers]
  );

  const goBack = useCallback(() => {
    if (step > 0) {
      setStep(step - 1);
    }
  }, [step]);

  const reset = useCallback(() => {
    setPhase('intro');
    setStep(0);
    setAnswers(Array(QUESTIONS.length).fill(null));
    setShareCopied(false);
  }, []);

  const downloadShareImage = useCallback(async () => {
    if (!result?.best) return;
    try {
      setDownloading(true);
      const blob = await generateShareImage(result.best);
      if (!blob) {
        setDownloading(false);
        return;
      }
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `koji-si-igrac-${result.best.id}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(url), 1500);
    } catch (err) {
      console.error('Generiranje slike nije uspjelo:', err);
    } finally {
      setDownloading(false);
    }
  }, [result]);

  const copyResultLink = useCallback(async () => {
    if (!result?.best) return;
    const url = `https://statarena.app/koji-si-igrac`;
    const text = `Ja sam ${result.best.name} (${result.best.nickname}). Koji si ti? ${url}`;
    try {
      if (navigator.share) {
        await navigator.share({ title: 'Koji si tip igrača?', text, url });
        return;
      }
    } catch (e) {
      // user otkazao share — fallback na clipboard
    }
    try {
      await navigator.clipboard.writeText(text);
      setShareCopied(true);
      setTimeout(() => setShareCopied(false), 2000);
    } catch (e) {
      console.warn('Clipboard nije dostupan:', e);
    }
  }, [result]);

  const progress = phase === 'quiz' ? ((step) / QUESTIONS.length) * 100 : 0;
  const currentQuestion = QUESTIONS[step];

  return (
    <div className="landing tipigraca-page">
      <PublicPageNav className="tipigraca-nav" />

      <main className="tipigraca-shell">
        {phase === 'intro' && (
          <section className="tipigraca-intro">
            <div className="tipigraca-intro-emoji" aria-hidden="true">⚽🧠</div>
            <h1>Koji si tip igrača?</h1>
            <p className="tipigraca-intro-sub">
              10 pitanja. 60 sekundi. Otkrij kojeg od 16 svjetskih nogometaša najviše
              podsjećaš — od Modrića do Haalanda, od Neuera do Mbappéa.
            </p>
            <button type="button" className="tipigraca-cta" onClick={start}>
              Pokreni quiz →
            </button>
            <ul className="tipigraca-intro-bullets">
              <li><span role="img" aria-label="Nogomet">✅</span> Bez registracije</li>
              <li><span role="img" aria-label="Nogomet">✅</span> Bez instalacije</li>
              <li><span role="img" aria-label="Nogomet">✅</span> Slika za Instagram &amp; TikTok</li>
            </ul>
          </section>
        )}

        {phase === 'quiz' && currentQuestion && (
          <section className="tipigraca-quiz">
            <div className="tipigraca-progress">
              <div
                className="tipigraca-progress-bar"
                style={{ width: `${progress}%` }}
                aria-hidden="true"
              />
            </div>
            <div className="tipigraca-step-indicator">
              Pitanje {step + 1} / {QUESTIONS.length}
            </div>

            <h2 className="tipigraca-question">{currentQuestion.label}</h2>

            <div className="tipigraca-options">
              {currentQuestion.options.map((opt, idx) => (
                <button
                  key={`${currentQuestion.id}-${idx}`}
                  type="button"
                  className="tipigraca-option"
                  onClick={() => selectOption(step, opt)}
                >
                  <span className="tipigraca-option-letter">
                    {String.fromCharCode(65 + idx)}
                  </span>
                  <span className="tipigraca-option-label">{opt.label}</span>
                </button>
              ))}
            </div>

            <div className="tipigraca-quiz-actions">
              <button
                type="button"
                className="tipigraca-back"
                onClick={goBack}
                disabled={step === 0}
              >
                ← Natrag
              </button>
              <button
                type="button"
                className="tipigraca-back tipigraca-back-ghost"
                onClick={reset}
              >
                Otkaži
              </button>
            </div>
          </section>
        )}

        {phase === 'result' && result?.best && (
          <section className="tipigraca-result" ref={resultRef}>
            <div
              className="tipigraca-result-hero"
              style={{
                background: `linear-gradient(135deg, ${result.best.color}, ${result.best.accent})`,
              }}
            >
              <div className="tipigraca-result-emoji" aria-hidden="true">
                {result.best.emoji}
              </div>
              <p className="tipigraca-result-eyebrow">TI SI</p>
              <h1 className="tipigraca-result-name">{result.best.name}</h1>
              <p className="tipigraca-result-nickname">{result.best.nickname}</p>
            </div>

            <p className="tipigraca-result-tagline">{result.best.tagline}</p>

            <div className="tipigraca-result-grid">
              <div className="tipigraca-result-card">
                <h3>Tvoje jake strane</h3>
                <ul>
                  {result.best.strengths.map((s) => (
                    <li key={s}><span role="img" aria-label="Nogomet">✅ </span> {s}</li>
                  ))}
                </ul>
              </div>
              <div className="tipigraca-result-card">
                <h3>Pazi na ovo</h3>
                <ul>
                  {result.best.weaknesses.map((w) => (
                    <li key={w}><span role="img" aria-label="Nogomet">⚠️</span> {w}</li>
                  ))}
                </ul>
              </div>
              <div className="tipigraca-result-card tipigraca-result-card-advice">
                <h3>Savjet</h3>
                <p>{result.best.advice}</p>
              </div>
            </div>

            <div className="tipigraca-result-actions">
              <button
                type="button"
                className="tipigraca-cta"
                onClick={downloadShareImage}
                disabled={downloading}
              >
                {downloading ? 'Generiranje...' : '📸 Preuzmi sliku za Instagram / TikTok'}
              </button>
              <button
                type="button"
                className="tipigraca-cta tipigraca-cta-secondary"
                onClick={copyResultLink}
              >
                {shareCopied ? '✅ Kopirano' : '🔗 Podijeli rezultat'}
              </button>
              <button
                type="button"
                className="tipigraca-cta tipigraca-cta-ghost"
                onClick={start}
              >
                ↻ Pokreni ponovo
              </button>
            </div>

            <details className="tipigraca-ranked">
              <summary>Vidi top 5 najbližih</summary>
              <ol className="tipigraca-ranked-list">
                {result.ranked.slice(0, 5).map(({ player, score }, idx) => (
                  <li key={player.id}>
                    <span className="tipigraca-ranked-rank">{idx + 1}.</span>
                    <span className="tipigraca-ranked-emoji">{player.emoji}</span>
                    <span className="tipigraca-ranked-name">{player.name}</span>
                    <span className="tipigraca-ranked-score">
                      {(score * 100).toFixed(0)}% match
                    </span>
                  </li>
                ))}
              </ol>
            </details>
          </section>
        )}
      </main>

      <section className="landing-section tipigraca-info">
        <div className="section-header landing-section-header">
          <h2>Kako radi quiz "Koji si tip igrača?"</h2>
          <p className="landing-section-sub">
            Brz, besplatan i jednostavan online quiz. 10 pitanja, jedan rezultat,
            slika spremna za dijeljenje. Bez registracije, bez instalacije.
          </p>
        </div>

        <div className="landing-steps">
          <div className="landing-step">
            <div className="landing-step-num">1</div>
            <h3>Odgovori na 10 pitanja</h3>
            <p>Pozicija, stil igre, fizika, mentalitet — svaki odgovor profilira tvoj stil.</p>
          </div>
          <div className="landing-step">
            <div className="landing-step-num">2</div>
            <h3>Pogledaj rezultat</h3>
            <p>Tvoj profil uspoređujemo sa 16 svjetskih nogometaša i biramo najbliže podudaranje.</p>
          </div>
          <div className="landing-step">
            <div className="landing-step-num">3</div>
            <h3>Preuzmi sliku</h3>
            <p>PNG u formatu 1080×1920 — savršen za Instagram story i TikTok.</p>
          </div>
          <div className="landing-step">
            <div className="landing-step-num">4</div>
            <h3>Izazovi prijatelje</h3>
            <p>Pošalji link, neka se i oni okušaju. Tko će dobiti istog igrača?</p>
          </div>
        </div>
      </section>

      <section className="landing-section landing-section-alt">
        <div className="section-header landing-section-header">
          <h2>Često postavljena pitanja o quizu</h2>
        </div>
        <div className="faq-list">
          {FAQ_ITEMS.map((item) => (
            <FaqItem key={item.question} question={item.question}>
              <p>{item.answer}</p>
            </FaqItem>
          ))}
        </div>
      </section>

      <footer className="landing-footer">
        <div className="landing-footer-inner">
          <div className="landing-footer-brand">
            <span className="landing-logo-mark" role="img" aria-label="Nogometna lopta">⚽</span>
            <span className="landing-logo-text">StatArena</span>
            <span className="landing-footer-tag">Aplikacija za rekreativni nogomet</span>
          </div>
          <div className="landing-footer-links">
            <Link to="/">Početna</Link>
            <Link to="/generator-timova">Generator timova</Link>
            <Link to="/raspored-turnira">Raspored turnira</Link>
            <Link to="/semafor-online">Online semafor</Link>
            <Link to="/penalty-shootout">Penalty shootout</Link>
            <Link to="/koji-si-igrac">Koji si tip igrača?</Link>
            <Link to="/login">Prijava</Link>
            <Link to="/register">Registracija</Link>
          </div>
          <div className="landing-footer-copy">
            © {new Date().getFullYear()} StatArena · statarena.app
          </div>
        </div>
      </footer>
    </div>
  );
};

export default KojiSiTipIgraca;

